// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"540":"bootstrapReact","635":"bootstrapSocialLink"}[chunkId] || chunkId) + "." + {"420":"74975b02","540":"a221be9d","565":"1061c191","635":"6541714c"}[chunkId] + ".chunk.css";
};